document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('rebuy.addBundleToCart', function(event){
    const $miniCart = document.querySelector("mini-cart");
    const sectionIDs = $miniCart.getSectionsToRender().map((section) => section.id);
    const url = `${location.pathname}?sections=${sectionIDs}`
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        const data = {
          sections: response
        }
        $miniCart.renderContents(data);
        $miniCart.openDrawer()
      })
      .catch((e) => {
        console.error(e);
      });
  });
});
